// extracted by mini-css-extract-plugin
export default {"container":"EditCardForm_container__2vXL-","previewSide":"EditCardForm_previewSide__m6YZG","configSide":"EditCardForm_configSide__BHISq"};